import { CSSProperties, ReactNode } from 'react'

type CenterProps = {
  children: ReactNode
  style?: CSSProperties
}

const Center = ({ children, style }: CenterProps) => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1, ...style }}>{children}</div>
)

export default Center
